<svg
viewbox="0 0 448 256"
fill="currentColor"
xmlns="http://www.w3.org/2000/svg">
<path
    d="M311.03 3.51501L303.959 10.585C299.273 15.271 299.273
    22.869 303.959 27.556L387.887 111H12C5.373 111 0 116.373 0
    123V133C0 139.627 5.373 145 12 145H387.887L303.959
    228.444C299.273 233.13 299.273 240.728 303.959 245.415L311.03
    252.485C315.716 257.171 323.314 257.171 328 252.485L444.485
    136.485C449.171 131.799 449.171 124.201 444.485 119.514L328
    3.51501C323.314 -1.17199 315.716 -1.17199 311.03 3.51501Z" />
</svg>